"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyleTitle = exports.StyleContainer = exports.StyleAllStore = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _color = _interopRequireDefault(require("webmotors-react-pj/tokens/color"));
var _responsive = _interopRequireDefault(require("webmotors-react-pj/tokens/responsive"));
const StyleTitle = exports.StyleTitle = _styledComponents.default.h3.withConfig({
  displayName: "StyleTitle",
  componentId: "sc-e1hl84-0"
})(["color:", ";font-family:Poppins;font-size:12px;font-style:normal;font-weight:700;line-height:18px;letter-spacing:0em;text-align:left;margin:8px 0px;"], (0, _color.default)('gray-1'));
const StyleContainer = exports.StyleContainer = _styledComponents.default.div.withConfig({
  displayName: "StyleContainer",
  componentId: "sc-e1hl84-1"
})(["max-height:calc(12vh - 12px);margin-bottom:12px;overflow-y:scroll;@media ", "{max-height:234px;}&::-webkit-scrollbar{background:transparent;width:8px;transition:width 0.3s;}&::-webkit-scrollbar-track{border-radius:16px;}&::-webkit-scrollbar-thumb{background-color:#8B8C99;border-radius:16px;border:2px solid #FFFFFF;}"], _responsive.default.lg);
const StyleAllStore = exports.StyleAllStore = _styledComponents.default.div.withConfig({
  displayName: "StyleAllStore",
  componentId: "sc-e1hl84-2"
})(["margin:0px 0 20px 0;"]);